module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAPCAYAAADZCo4zAAAAoklEQVQoU2NkIAAYscn39fVx/v79uwUo14uhACT569evTUBJ+f///5ujKECW/PPnj2NNTc1TuAJskiDrwQpwSYIVNDQ0cADBZpCdMGORHc7Y0dGhz8jIeBYoWFleXt6N7iuwFZ2dnfFAajYQpwMVzUcxAcaBKQKallZWVrYAJo7iTWyKMAIKXRHWoIYpAoakKVYFIPu7u7v1Hj16dBOnApgjAdeSW4DV2DPSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u.png
// module id = svuC
// module chunks = 15